import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Data, Router } from "@angular/router";
import { CircularInjectionHelper } from "../services/circularInjectionHelper";
import { IObjectObserver } from "../services/IObjectObserver";
import { ObjectObserverFactory } from "../services/objectObserverFactory";
import { ContentType } from "../shared/contentTypes";
import { WebshopSettingsDataModel2, WebshopSettingsDMKey } from "../shared/models";

@Injectable({
  providedIn: "root"
})
export class WebshopSettingsResolver implements Resolve<WebshopSettingsDataModel2> {
  private _webshopSettingsObsServ: IObjectObserver<WebshopSettingsDataModel2>;

  constructor(private _objObsInjectHelper: CircularInjectionHelper) {
    this._webshopSettingsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<WebshopSettingsDataModel2>(ContentType.WebshopSettings, _objObsInjectHelper);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<WebshopSettingsDataModel2> {
    const me = this;
    return new Promise<WebshopSettingsDataModel2>((resolve, reject) => {
      me._webshopSettingsObsServ.GetObject(WebshopSettingsDMKey)
        .then((response) => {
          resolve(response);
        })
        .catch(e => {
          me._objObsInjectHelper.coreLogService.error("WebshopSettingsResolver", "_webshopSettingsObsServ.GetObject(WebshopSettingsDMKey)", e);
          resolve(null);
        })
    });
  }
}